export const adminWrappingApi = {

    getAll () {
        return axios.get(`/api/admin/wrapping-management`)
    },

    findWrapping (query) {
        return axios.post(`/api/admin/wrapping-management/search`, {
            query: query
        })
    }

}
